
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DatePicker from 'vue2-datepicker';
import { Mounted } from '../decorators';
import { addItemToLocalStorage, EventBus, hasElements, removeItemFromLocalStorage, StoregeKey, TypeEventBus } from '../utils';



@Component({
    components: { DatePicker }
})
export default class DateRange extends Vue {
    rangeDate: Date[] = [];
    @Prop() rangeSelected: Date[];

    get datepicker(): HTMLFormElement {
        return this.$refs.datepicker as HTMLFormElement;
    }

    @Mounted
    ready() {
        if (hasElements(this.rangeSelected)) {
            this.handleRangeSelected(this.rangeSelected);
        }
    }

    handleClear() {
        this.rangeDate = [];
        removeItemFromLocalStorage(StoregeKey.FILTERED_DATE_RANGE)
    }

    @Watch('rangeSelected')
    observableRangeSelected(value: Date[]) {
        this.handleRangeSelected(value);
    }

    handleRangeSelected(value: Date[]) {
        
    }

    @Watch('rangeDate')
    observableRangeDate(value: Date[]) {
       
    }

    saveFilterLocalStorage(dateA, dateB) {
        addItemToLocalStorage(StoregeKey.FILTERED_DATE_RANGE, {
            datetime_from: dateA,
            datetime_to: dateB
        })
    }

    reset(): void {
        this.handleClear();
        if (this.isCalendarVisible()) {
            this.datepicker.closePopup();
            setTimeout(() => {
                this.datepicker.showPopup();
            }, 1);
        }
    }

    isCalendarVisible(): boolean {
        return this.datepicker.popupVisible;
    }

    mounted() {
        this.datepicker.showPopup();
        EventBus.$on(TypeEventBus.OPEN_DATE_RANGE_POPUP, () => {
            setTimeout(() => {
                this.datepicker.popupVisible = true;
            }, 500);
        });
        EventBus.$on(TypeEventBus.CLOSE_DATEPICKER_POPUP, () => {
            this.datepicker.closePopup();
        });
    }

    handleOpen(): void {
        EventBus.$emit(TypeEventBus.OPEN_DATE_RANGE);
        EventBus.$on(TypeEventBus.CLOSE_DATEPICKER_POPUP, () => {
            this.datepicker.closePopup();
        });
    }
}
